import { makeMediaInstance } from './features';
export { makeDhProvider } from './providers';
export { ActionType, isDprType, ImageFormats, GlovoMediaError, GlovoInvalidImageSourceError, } from './types';
export { fileHasValidDimensions, fileHasValidFormat, fileHasValidSize, DEFAULT_VALIDATION_RULES, } from './image-validations';
export { getImageDimensions, getImageFormat, getImageSizeInMb } from './image-validations/helpers';
export const glovoMedia = makeMediaInstance();
//# sourceMappingURL=index.js.map